<template>
    <span class="hover:cursor-pointer" @click="openModal()">
        <slot name="trigger" />
    </span>

    <Teleport to="body" v-if="visible">
        <div
            tabindex="-1"
            class="fixed left-0 right-0 top-0 z-50 flex h-full items-center justify-center bg-black/60"
            @click.self="closeOnBgClick ? closeModal() : null"
        >
            <div class="flex flex-col gap-0">
                <div class="" v-if="showHeader">
                    <div :class="headerCss" v-if="$slots.header">
                        <slot name="header" />
                    </div>
                    <div v-else :class="headerCss">
                        <div class="relative flex items-center justify-between">
                            <div
                                v-if="showTitle && title"
                                class="pr-12 font-semibold"
                            >
                                {{ title }}
                            </div>
                            <div
                                v-if="showCloseX"
                                class="text-gray-500 hover:cursor-pointer hover:text-gray-900"
                                @click="closeModal()"
                            >
                                <svg
                                    class="fill-current"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M18 6L6 18"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M6 6L18 18"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                        <!--                    <div class="relative" v-else>-->
                        <!--                        <div-->
                        <!--                            v-if="showCloseX"-->
                        <!--                            class="absolute right-6 top-6 ml-4 border-l border-white/30 pl-4 text-gray-500 hover:cursor-pointer hover:text-gray-900"-->
                        <!--                            @click="closeModal()"-->
                        <!--                        >-->
                        <!--                            <svg-->
                        <!--                                class="fill-current"-->
                        <!--                                width="24"-->
                        <!--                                height="24"-->
                        <!--                                viewBox="0 0 24 24"-->
                        <!--                                xmlns="http://www.w3.org/2000/svg"-->
                        <!--                            >-->
                        <!--                                <path-->
                        <!--                                    d="M18 6L6 18"-->
                        <!--                                    stroke="currentColor"-->
                        <!--                                    stroke-width="2"-->
                        <!--                                    stroke-linecap="round"-->
                        <!--                                    stroke-linejoin="round"-->
                        <!--                                />-->
                        <!--                                <path-->
                        <!--                                    d="M6 6L18 18"-->
                        <!--                                    stroke="currentColor"-->
                        <!--                                    stroke-width="2"-->
                        <!--                                    stroke-linecap="round"-->
                        <!--                                    stroke-linejoin="round"-->
                        <!--                                />-->
                        <!--                            </svg>-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                    </div>
                </div>
                <div
                    :class="
                        'relative block flex max-h-[80vh] flex-col overflow-y-auto' +
                        ' ' +
                        contentCss
                    "
                >
                    <slot name="content" />

                    <template v-if="$slots.controls">
                        <!--                        <div class="overflow-y-auto">-->
                        <!--                            <div class="mb-8">-->
                        <!--                                <slot name="content" />-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <div
                            class="drop-shadow-top flex h-[80px] flex-col items-end justify-end bg-white"
                        >
                            <slot name="controls" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<script>
export default {
    name: "NewModal",
    emits: ["modal-opened", "modal-closed"],
    props: {
        title: {
            type: String,
            default: "",
        },
        size: {
            type: String,
            default: "md",
        },
        startOpen: {
            type: Boolean,
            default: false,
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
        showCloseX: {
            type: Boolean,
            default: true,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        closeOnBgClick: {
            type: Boolean,
            default: true,
        },
        modalClasses: {
            type: String,
            default:
                "rounded-b border border-gray-50 border-t-none bg-white p-6",
        },
        contentClasses: {
            type: String,
            default:
                "rounded-b border border-gray-50 border-t-none bg-white p-6",
        },
        headerClasses: {
            type: String,
            default: "rounded-t border border-gray-50 bg-white p-6",
        },
    },
    data() {
        return {
            visible: false,
        };
    },
    created: function () {},
    methods: {
        openModal() {
            this.visible = true;
            this.$emit("modal-opened");
        },
        closeModal() {
            this.$emit("modal-closed");
            this.visible = false;
        },
    },
    mounted() {
        if (this.startOpen) {
            this.openModal();
        }
    },
    computed: {
        contentCss() {
            return (
                "m-4 mt-0 max-w-" +
                this.size +
                " " +
                (this.showHeader ? "" : "rounded-t") +
                " " +
                this.modalClasses
            );
        },
        headerCss() {
            return "mx-4 mt-0 max-w-" + this.size + " " + this.headerClasses;
        },
    },
};
</script>
